var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cms-icon-block" }, [
    _c("div", { staticClass: "cms-icon-block__shape", style: _vm.shapeStyle }, [
      _c("i", {
        staticClass: "cms-icon-block__icon",
        class: "fa fa-" + _vm.icon,
        style: _vm.iconStyle,
      }),
    ]),
    _vm._v(" "),
    _vm.label
      ? _c(
          "div",
          { staticClass: "cms-icon-block__label", style: _vm.labelStyle },
          [_vm._v(_vm._s(_vm.label))]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }